import React from "react";

export default function NotificationsPage() {
    const notifications = [
    { id: 1, text: "Order #1234 has been shipped", time: "2m ago" },
    { id: 2, text: "New message from support team", time: "10m ago" },
    { id: 3, text: "Password changed successfully", time: "1h ago" },
    { id: 4, text: "Your subscription has been renewed", time: "1d ago" },
  ];

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4">
        All Notifications
      </h1>

      {notifications && notifications.length > 0 ? (
        <ul className="space-y-3">
          {notifications.map((n) => (
            <li
              key={n.id}
              className="p-4 bg-white dark:bg-[#1A1A1B] shadow-sm rounded-lg bg-gray-50 dark:hover:bg-[#2D2D2D] transition"
            >
              <p className="text-sm text-gray-700 dark:text-gray-300">
                {n.text}
              </p>
              <span className="text-xs text-gray-500">{n.time}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500 dark:text-gray-400">
          No notifications found.
        </p>
      )}
    </div>
  );
}
